import { ThunkType } from "../../../../../core/store/reducers";
import { getTradeByClientsExcel } from "../api/getTradeByClientsExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../tradeByClientsDataSlice";

export const downloadTradeByClientsExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.tradeByClients;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getTradeByClientsExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "TradeByClients.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
